import moment from 'moment'
import jwtDecode from 'jwt-decode'
export default {
    // expiry as a unix timestamp in seconds, or null when the token cannot be read
    expiresAt(jwtToken) {
        try {
            return jwtDecode(jwtToken).exp || null
        } catch (e) {
            return null
        }
    },
    isJwtExpired(jwtToken) {
        if (!jwtToken) {
            return true
        }
        try {
            return moment().unix() > jwtDecode(jwtToken).exp
        } catch (e) {
            return true
        }
    }
}
